import {
  CANCEL_REQUEST_REASON,
  USER_SUBSCRIPTION_STATUS,
  SUBSCRIPTION_CADENCE
} from './extensions-subscriptions.constants'
import {
  IExtensionsSubscription,
  IExtensionsSubscriptionQuota,
  IExtensionsSubscriptionUsageQuota,
  IProductFruitsExtensionsSubscription,
  IProductFruitsExtensions
} from './extensions-subscriptions.interfaces'

const getExtensionsSubscription = (subscriptions: IExtensionsSubscription[]): IProductFruitsExtensionsSubscription => {
  const extensionsSubscription = subscriptions?.find(
    subscription => subscription.activeSubscriptionPlan.plan.segment === 'EXTENSIONS'
  )

  if (!extensionsSubscription) {
    return {
      plan: '',
      product: '',
      formatedDate: '',
      creationDate: 0,
      planMigratedFromKlick: '',
      subscriptionDelayed: '',
      userHasChurned: '',
      cadence: ''
    }
  }

  const {
    cadence = 0,
    migrated,
    status,
    subscriptionCancelRequest,
    activeSubscriptionPlan: {
      plan: { planCode, planType },
      creationDate
    }
  } = extensionsSubscription

  const creationDateFormated = new Date(creationDate)
  const formatedDateOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }
  const formatedDate = creationDateFormated.toLocaleString('pt-br', formatedDateOptions)
  const subscriptionDelayed = status === USER_SUBSCRIPTION_STATUS.DELAYED
  const userHasChurned = subscriptionCancelRequest?.reason === CANCEL_REQUEST_REASON.VOLUNTARY

  const productFruitsSubscription: IProductFruitsExtensionsSubscription = {
    plan: planCode,
    product: planType,
    formatedDate,
    cadence: SUBSCRIPTION_CADENCE[cadence],
    creationDate,
    planMigratedFromKlick: String(migrated),
    subscriptionDelayed: String(subscriptionDelayed),
    userHasChurned: String(userHasChurned)
  }

  return productFruitsSubscription
}

const getProductFruitsUsageQuota = (quotas: IExtensionsSubscriptionQuota[]): IExtensionsSubscriptionUsageQuota => {
  const leadQuota = quotas?.find(quota => quota?.key === 'LEAD')
  const pageQuota = quotas?.find(quota => quota?.key === 'PAGE')
  const emailQuota = quotas?.find(quota => quota?.key === 'EMAIL')

  return {
    usedLeadsConsumption: leadQuota?.consumption || 0,
    usedLeadsMaxValue: leadQuota?.maxValue || 0,
    usedPagesConsumption: pageQuota?.consumption || 0,
    usedPagesMaxValue: pageQuota?.maxValue || 0,
    usedEmailsConsumption: emailQuota?.consumption || 0,
    usedEmailsMaxValue: emailQuota?.maxValue || 0
  }
}

export const getProductFruitsExtensionSubscriptionData = (
  subscriptions: IExtensionsSubscription[],
  quotas: IExtensionsSubscriptionQuota[]
): IProductFruitsExtensions => {
  const extensionsSubscription = getExtensionsSubscription(subscriptions)
  const extensionsSubscriptionQuota = getProductFruitsUsageQuota(quotas)

  return {
    ...extensionsSubscription,
    ...extensionsSubscriptionQuota
  }
}
